<template>
  <div>
    <div class="bg vux-1px-b vux-1px-t">
      <div class="vux-1px-b">
        <x-input
          title="渔船号"
          text-align="right"
          placeholder="请输入渔船号"
          v-model="params.shipCode"
          placeholder-align="right"
        ></x-input>
      </div>
      <div class="vux-1px-b">
        <x-input
          title="船主姓名"
          text-align="right"
          placeholder="请输入船主姓名"
          v-model="params.shipowner"
          placeholder-align="right"
        ></x-input>
      </div>
      <div>
        <x-input
          title="说明"
          text-align="right"
          placeholder="请输入"
          v-model="params.remark"
          placeholder-align="right"
        ></x-input>
      </div>
    </div>
    <div class="bg vux-1px-b vux-1px-t">
      <div class="vux-1px-b">
        <div style="padding: 10px 15px;height: 25px;line-height: 25px;">
          渔船共享人<span class="add" @click="show = true">新增</span>
        </div>
        <confirm
          v-model="show"
          title="新增渔船共享人"
          @on-confirm="addShare"
          :close-on-confirm="false"
        >
          <x-input
            title="姓名"
            text-align="right"
            placeholder=""
            v-model="share.name"
            placeholder-align="right"
          ></x-input>
          <x-input
            title="手机号"
            text-align="right"
            placeholder=""
            v-model="share.phone"
            placeholder-align="right"
          ></x-input>
        </confirm>
      </div>
      <div
        v-if="shareList.length > 0"
        style="padding: 10px 15px;overflow: hidden"
      >
        <div :key="item.id" class="shareMan" v-for="item in shareList">
          {{ item.clientName }}
        </div>
      </div>
    </div>
    <div class="bg vux-1px-b vux-1px-t">
      <div class="imgBox">
        <div>船舶证件</div>
        <upload-file
          :params="{ path: '/addShip' }"
          v-model="params.shipDocument"
        >
        </upload-file>
      </div>
    </div>
    <div class="change" v-if="loadingImg === true">
      <img class="loadingImg" src="../../assets/loading.gif" />
    </div>
    <div class="change" v-else @click="modifyShip">修改</div>
  </div>
</template>

<script>
import { Confirm } from "vux";
import {
  getShipDetail,
  shareShip,
  getShareList,
  modifyShip
} from "../../api/ship";
import UploadFile from "@/components/Upload/UploaderFile";

export default {
  name: "shipDetail",
  components: {
    Confirm,
    UploadFile
  },
  data() {
    return {
      loadingImg: false,
      show: false,
      params: {
        shipDocument: []
      },
      share: {
        id: this.$route.params.id,
        name: "",
        phone: ""
      },
      shareList: ""
    };
  },
  created() {
    this.getShipDetail();
    this.getShareList();
  },
  methods: {
    getShareList() {
      getShareList({ shipId: this.$route.params.id })
        .then(res => {
          this.shareList = res;
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    addShare() {
      this.$vux.loading.show();
      shareShip(this.share)
        .then(() => {
          this.$vux.loading.hide();
          this.show = false;
          this.getShareList();
        })
        .catch(err => {
          this.$vux.loading.hide();
          this.$showError(err);
        });
    },
    getShipDetail() {
      getShipDetail({ id: this.$route.params.id })
        .then(res => {
          this.params.shipDocument = [];
          this.params.shipCode = res.shipCode;
          this.params.shipowner = res.shipowner;
          this.params.remark = res.remark;
          if (res.shipDocument) {
            if (res.shipDocument.indexOf(",") > 0) {
              this.params.shipDocument = res.shipDocument.split(",");
            } else {
              this.params.shipDocument.push(res.shipDocument);
            }
          } else {
            this.params.shipDocument = [];
          }
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    modifyShip() {
      if (this.params.shipCode == "") {
        this.$showError("请输入渔船号");
      } else if (this.params.shipowner == "") {
        this.$showError("请输入船主姓名");
      } else if (this.params.shipDocument.length == 0) {
        this.$showError("请上传船舶证件");
      } else {
        this.loadingImg = true;
        modifyShip({ ...this.params, id: this.$route.params.id })
          .then(() => {
            this.loadingImg = false;
            this.$showError("修改成功");
            this.getShipDetail();
          })
          .catch(err => {
            this.loadingImg = false;
            this.$showError(err);
          });
      }
    }
  }
};
</script>

<style scoped>
.bg {
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  margin: 20px 0;
}
.imgBox {
  padding: 20px 30px;
}
.imgBox img {
  margin-top: 20px;
  width: 220px;
  height: 220px;
  display: block;
  overflow: hidden;
}
.change {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: 88px;
  line-height: 88px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  background: #039df8;
}
.loadingImg {
  width: 32px;
  height: 32px;
  line-height: 86px;
}
.add {
  display: block;
  float: right;
  line-height: 50px;
  width: 120px;
  height: 50px;
  border: 1px solid rgba(165, 220, 253, 1);
  border-radius: 25px;
  text-align: center;
  color: #039df8;
}
.shareMan {
  padding: 10px 20px;
  height: 50px;
  line-height: 50px;
  background: rgba(246, 246, 246, 1);
  border: 1px solid rgba(226, 226, 226, 1);
  border-radius: 6px;
  font-size: 14px;
  color: #5e5e5e;
  text-align: center;
  float: left;
  margin: 0 20px 10px 0;
}
.shipImg {
  display: block;
  float: left;
  margin: 0 20px 20px 0;
}
</style>
